import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const CourseCard = React.memo(({
  id,
  price,
  title,
  description,
  instructor,
  duration,
  students,
  level,
  category,
  progress,
  index,
  onEnroll
}) => {
  const navigate = useNavigate();

  const handleViewDetails = useCallback(() => {
    navigate(`/course/${id}`);
  }, [navigate, id]);

  const hasProgress = typeof progress === 'number' && progress > 0;
  const accentClass = index % 2 === 0 ? 'accent-amber' : 'accent-terracotta';

  return (
    <article className={`fundisha-course-card ${accentClass}`} role="listitem">
      <div className="fundisha-course-accent" aria-hidden="true"></div>
      <div className="fundisha-course-content">
        <span className="fundisha-course-tag">{category || level || 'General'}</span>
        <h3 className="fundisha-course-title">{title}</h3>
        <p className="fundisha-course-meta-text">By {typeof instructor === 'object' ? instructor.name : instructor}</p>

        {hasProgress ? (
          <>
            <div className="fundisha-course-progress" aria-label={`Progress: ${progress}%`}>
              <span style={{ width: `${progress}%` }}></span>
            </div>
            <p className="fundisha-course-meta-text">{progress}% complete</p>
          </>
        ) : (
          <button className="fundisha-enroll-link" type="button" onClick={() => onEnroll(id)}>
            Enroll ->
          </button>
        )}

        <p className="fundisha-course-meta-text">
          {description || 'Hands-on projects and guided lessons for practical mastery.'}
        </p>

        <div className="fundisha-course-footer">
          <span>{duration} | {students} learners</span>
          <span>{price}</span>
          <button type="button" className="fundisha-course-view-btn" onClick={handleViewDetails}>
            View
          </button>
        </div>
      </div>
    </article>
  );
});

export default CourseCard;
